import i18next from 'i18next';
import {Observable} from 'rxjs';

import {combineEpics} from 'web-app/util/redux-observable';
import {addTagObservable, removeTagObservable} from 'web-app/react/entities/children/epics';
import * as GlobalEventActions from 'web-app/react/global-event/actions';

import * as Actions from './actions';

const addTag = action$ =>
    action$.ofType(Actions.add.type).mergeMap(({payload}) =>
        addTagObservable(payload.childId, payload.tagId)
            .flatMap(successAction => [
                successAction,
                Actions.addSuccess.action(payload.childId, payload.tagId),
                GlobalEventActions.updateSuccess.action(i18next.t('childProfile.tagAdded')),
            ])
            .catch(() => Observable.of(Actions.addFailed.action(payload.childId, payload.tagId))),
    );

const removeTag = action$ =>
    action$.ofType(Actions.remove.type).mergeMap(({payload}) =>
        removeTagObservable(payload.childId, payload.tagId)
            .flatMap(successAction => [
                successAction,
                Actions.removeSuccess.action(payload.childId, payload.tagId),
                GlobalEventActions.updateSuccess.action(i18next.t('childProfile.tagRemoved')),
            ])
            .catch(() => Observable.of(Actions.removeFailed.action(payload.childId, payload.tagId))),
    );

export default combineEpics(addTag, removeTag);
